import React from 'react';

import { GuestAccountMenu } from 'navigation/components/GuestAccountMenu';
import { UserAccountMenu } from 'navigation/components/UserAccountMenu';
import { UserMainMenu } from 'navigation/components/UserMainMenu';
import { GuestMainMenu } from 'navigation/components/GuestMainMenu';

type Props = {};

export const NavigationContainer: React.FC<Props> = () => {
  const ref = React.createRef<HTMLDivElement>();
  const [isMainMenuOpen, setMainMenuOpen] = React.useState(false);
  const [isAccountMenuOpen, setAccountMenuOpen] = React.useState(false);

  const toggleMainMenu = React.useCallback(() => {
    setMainMenuOpen(!isMainMenuOpen);
    setAccountMenuOpen(false);
  }, [isMainMenuOpen]);

  const toggleAccountMenu = React.useCallback(() => {
    setMainMenuOpen(false);
    setAccountMenuOpen(!isAccountMenuOpen);
  }, [isAccountMenuOpen]);

  React.useEffect(() => {
    const html = document.getElementsByTagName('html')[0];
    if (isMainMenuOpen) {
      html.classList.add('is-main-menu-open');
      html.classList.remove('is-account-menu-open');
    } else if (isAccountMenuOpen) {
      html.classList.add('is-account-menu-open');
      html.classList.remove('is-main-menu-open');
    } else {
      html.classList.remove('is-main-menu-open', 'is-account-menu-open');
    }
  }, [isMainMenuOpen, isAccountMenuOpen]);

  return (
    <div className='navigation-mobile-item' ref={ref}>
      <button
        onClick={toggleMainMenu}
        className='navigation-menu__toggle navigation-menu__toggle--menu btn--blended'
      >
        <span className='navigation-menu__toggle-icon icon-burger' />
        Menu
      </button>
      {sedition.user.isGuest() && <GuestMainMenu open={isMainMenuOpen} />}
      {!sedition.user.isGuest() && <UserMainMenu open={isMainMenuOpen} />}
      <span className='navigation-menu__toggle--search-wrap'>
        <a
          className='navigation-menu__toggle navigation-menu__toggle--search icon-search js-search-toggle'
          href='/search'
        />
      </span>
      <button
        onClick={toggleAccountMenu}
        className='navigation-menu__toggle navigation-menu__toggle--account btn--blended'
      >
        {sedition.user.isGuest() ? null : (
          <span className='d-none d-md-inline pr-mini'>Account</span>
        )}
        {!sedition.user.isGuest() && (
          <img
            alt='Avatar'
            className='avatar navigation-menu__avatar'
            src={sedition.user.get('avatarUrl')}
            width='36'
            height='36'
          />
        )}
        <span className='navigation-menu__toggle-icon icon-down' />
        <span className='navigation-menu__toggle-icon icon-up' />
      </button>
      {sedition.user.isGuest() && <GuestAccountMenu open={isAccountMenuOpen} />}
      {!sedition.user.isGuest() && (
        <UserAccountMenu userUrl={sedition.user.get('url') || ''} open={isAccountMenuOpen} />
      )}
    </div>
  );
};
